/* eslint-disable no-undef */
let cursors = null;
let isInitialized = false;

// Initialize cursors on first load
const initializeCursors = () => {
  if (!isInitialized && typeof document !== 'undefined') {
    cursors = document.querySelectorAll("[data-cursor]");
    isInitialized = true;
  }
};

// Simple smooth cursor tracking with requestAnimationFrame
let lastX = 0;
let lastY = 0;
let dotX = 0;
let dotY = 0;
let rafId = null;

const smoothMoveDot = () => {
  // Ease the dot position towards cursor
  dotX += (lastX - dotX) * 0.2;
  dotY += (lastY - dotY) * 0.2;

  if (cursors && cursors.length > 1) {
    cursors[1].style.left = `${dotX}px`;
    cursors[1].style.top = `${dotY}px`;
  }

  rafId = requestAnimationFrame(smoothMoveDot);
};

window.addEventListener("mousemove", function (event) {
  initializeCursors();

  lastX = event.clientX;
  lastY = event.clientY;

  if (cursors && cursors.length > 0) {
    cursors[0].style.left = `${lastX}px`;
    cursors[0].style.top = `${lastY}px`;
  }

  // Start smooth animation if not already running
  if (!rafId) {
    rafId = requestAnimationFrame(smoothMoveDot);
  }
});

// Delegate event listener for hover state using event delegation
document.addEventListener("mouseover", function (e) {
  if (cursors && cursors.length > 0) {
    const target = e.target;
    const isClickable = target.tagName === "BUTTON" || 
                       target.tagName === "A" ||
                       target.closest("button") ||
                       target.closest("a");

    if (isClickable) {
      for (let i = 0; i < cursors.length; i++) {
        cursors[i].classList.add("hovered");
      }
    }
  }
});

document.addEventListener("mouseout", function (e) {
  if (cursors && cursors.length > 0) {
    const target = e.target;
    const isClickable = target.tagName === "BUTTON" || 
                       target.tagName === "A" ||
                       target.closest("button") ||
                       target.closest("a");

    if (isClickable) {
      for (let i = 0; i < cursors.length; i++) {
        cursors[i].classList.remove("hovered");
      }
    }
  }
});

// Cleanup on page unload
window.addEventListener("beforeunload", () => {
  if (rafId) {
    cancelAnimationFrame(rafId);
  }
});